import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, Divider, IconButton } from '@mui/material'
import { Svg, Path } from 'react-native-svg'
import { View, TouchableOpacity, ViewStyle } from 'react-native'
import { Close } from '@mui/icons-material'
import { Text } from '../text'
import { color, spacing } from '../../theme'

export interface ReportPostDialogProps {
  open: boolean
  onSubmit: (reportValue: any) => void
  onClose: () => void
  isComment?: boolean
}

export function ReportPostDialog(props: ReportPostDialogProps) {
  const { open, onSubmit, onClose, isComment = false } = props
  const [reportReason, setReportReason] = useState<number | number>(0)

  const handleConfirm = (reason: any) => {
    onSubmit(reason)
    handleClose()
  }

  const handleClose = () => {
    onClose()
    setReportReason(0)
  }

  useEffect(() => {
    if (!open) {
      // setMessage(undefined)
    }
  }, [open])

  return (
    <Dialog aria-labelledby="confirmation-dialog-title" open={open}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: 20,
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <Text
          variant="body1Emphasized"
          text="Report"
          style={{
            fontSize: '20px',
          }}
        />
        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            handleClose()
          }}
          size="large"
        >
          <Close htmlColor={color.shade50} style={{ fontSize: 22 }} />
        </IconButton>
      </div>

      <Divider />

      <DialogContent style={{ paddingBottom: 40 }}>
        <View
          style={{
            alignItems: 'center',
            marginBottom: 24,
          }}
        >
          <View style={{ display: 'flex', flexDirection: 'column' }}>
            <Text
              variant="label"
              tx={isComment ? 'Discuss.reportCommentWhy' : 'Discuss.reportWhy'}
              style={{ fontSize: '20px', marginBottom: 8 }}
            />
            <Text variant="body1" style={{ color: color.shade50 }} tx="Discuss.reportHelp" />
          </View>
        </View>

        <View>
          <TouchableOpacity onPress={() => setReportReason(1)}>
            <View style={reportReason === 1 ? REPORT_REASON_SELECTED : REPORT_REASON}>
              <Text
                style={{ color: reportReason === 1 ? color.white : color.black }}
                variant="body1Emphasized"
                tx="Discuss.reportSpam"
              />
            </View>
          </TouchableOpacity>

          <TouchableOpacity onPress={() => setReportReason(2)}>
            <View style={reportReason === 2 ? REPORT_REASON_SELECTED : REPORT_REASON}>
              <Text
                style={{ color: reportReason === 2 ? color.white : color.black }}
                variant="body1Emphasized"
                tx="Discuss.reportHarmful"
              />
            </View>
          </TouchableOpacity>

          <TouchableOpacity onPress={() => setReportReason(3)}>
            <View style={reportReason === 3 ? REPORT_REASON_SELECTED : REPORT_REASON}>
              <Text
                style={{ color: reportReason === 3 ? color.white : color.black }}
                variant="body1Emphasized"
                tx="Discuss.reportSelfharm"
              />
            </View>
          </TouchableOpacity>
        </View>
      </DialogContent>
      <DialogActions
        style={{ paddingTop: 0, paddingRight: 20, paddingBottom: 20, paddingLeft: 20 }}
      >
        <Button
          variant="contained"
          color="primary"
          disableElevation
          disabled={reportReason === 0}
          onClick={(e) => {
            e.stopPropagation()
            handleConfirm(reportReason)
          }}
          style={{ width: '100%', marginBottom: '20px' }}
        >
          <Text variant="body1Emphasized" text="Submit" style={{ color: color.white }} />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const REPORT_REASON: ViewStyle = {
  borderRadius: 16,
  backgroundColor: color.palette.athensGrey,
  alignSelf: 'flex-start',
  paddingHorizontal: spacing[2],
  paddingVertical: spacing[1],
  marginBottom: spacing[4],
}

const REPORT_REASON_SELECTED: ViewStyle = {
  borderRadius: 16,
  backgroundColor: color.palette.blueLink,
  alignSelf: 'flex-start',
  paddingHorizontal: spacing[2],
  paddingVertical: spacing[1],
  marginBottom: spacing[4],
}
